// reducers/subCategoryReducers.js
import { SUBCATEGORY_LIST_FAIL, SUBCATEGORY_LIST_REQUEST, SUBCATEGORY_LIST_SUCCESS } from '../constants/categoryConstants';

export const subCategoryListReducer = (state = { subCategories: [] }, action) => {
  switch (action.type) {
    case SUBCATEGORY_LIST_REQUEST:
      return { loading: true, subCategories: [] };
    case SUBCATEGORY_LIST_SUCCESS:
      return { loading: false, subCategories: action.payload };
    case SUBCATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
